module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note 5 Silver Titanium.736e74ac.png";